import { Box } from '@mui/material';
import { ContextItems } from 'src/@types/ai';
import { DocItem } from 'src/@types/docs';
import { DriveContentType, IDriveContent } from 'src/@types/drive';
import FileThumbnail from 'src/components/file-thumbnail';
import Iconify from 'src/components/iconify';
import { UserRecent } from 'src/hooks/recents';
import { NavRecentItemIcon } from 'src/layouts/DashboardLayout/NavRecents/NavRecentItemIcon';

const ContextIcon = {
  ['image']: () => <Iconify icon="tabler:photo" />,
  ['file']: () => <Iconify icon="tabler:file" />,
  ['drive']: (drive: IDriveContent) =>
    drive.type === DriveContentType.FOLDER ? (
      <Box
        component="img"
        src="/assets/icons/files/ic_folder.svg"
        sx={{ width: 18, height: 18 }}
      />
    ) : (
      <FileThumbnail file={drive.name} imgSx={{ width: 18, height: 18 }} />
    ),
  ['doc']: (doc: DocItem) =>
    doc.icon ? (
      <em-emoji shortcodes={doc.icon.value} />
    ) : (
      <Iconify icon="tabler:file-description" />
    ),
  ['recent']: (recent: UserRecent) => <NavRecentItemIcon recent={recent} />,
};

export const AIContextIcon = ({ item }: { item: ContextItems }) => {
  return ContextIcon[item.type](item[item.type] as any);
};
